module.exports = __webpack_public_path__ + "img/block3.4320e427.png";